import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { cartReducer } from './store/reducers/cartReducer';
import { BrowserRouter as Router } from 'react-router-dom';
import { history } from './common/history';
import '@algolia/autocomplete-theme-classic';
import TestErrorComponent from './TestErrorComponent.js'; 
import AlgoSalioMal from './components/AlgoSalioMal.js';

import * as Sentry from '@sentry/react';

/* if (process.env.NODE_ENV === 'production') {

} */

  console.log('Sentry Corriendo >');
  Sentry.init({
    dsn: "https://cc8252e08d307e41e6a7546c4dbdc423@o4509046198763520.ingest.us.sentry.io/4509633149075456",
    sendDefaultPii: true,
    performance: {
      tracesSampleRate: 1.0,
    }
  });

const store = createStore(cartReducer);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <div className="custom-wrapper-body">
        <Router history={history}>
          <Sentry.ErrorBoundary fallback={<AlgoSalioMal />}>
            <App />
            {/* <TestErrorComponent />  */}
          </Sentry.ErrorBoundary>
        </Router>
      </div>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
